(function ($, Promise) {

    // Constructor
    function VICCHomeImageCanvas(opts) {

      this.animateValue = 0;
      this.lastRenderedAnimateValue = -1;

      this.scene = false;
      this.camera = false;
      this.renderer = false;
      this.mat = false;
      this.resizeCallback = this.resize.bind(this);
      this.isFirstDraw = true;
      this.width = 0;
      this.height = 0
      this.enabled = false;
      this.ready = false;

      this.parentSelector = opts.parentSelector || console.warn("no parent selector");
      var dispImage = opts.displacementImage || console.warn("displacement image missing");
      var image1 = opts.image1 || console.warn("first image missing");
      var image2 = opts.image2 || console.warn("second image missing");
      var intensityX = opts.intensityX || 0.2;
      var intensityY = opts.intensityY || 0.05;

      Promise.all([
        this.loadShaders("/shaders/displacement.vert.glsl", "/shaders/displacement.frag.glsl"),
        this.loadTextures([image1, image2, dispImage]),
      ]).then($.proxy(function (values) {

        var texture1 = values[1][0];
        var texture2 = values[1][1];
        var disp = values[1][2];

        this.scene = new THREE.Scene();

        this.camera = new THREE.OrthographicCamera(-100, 100, 100, -100, 1, 1000);
        this.camera.position.z = 1;

        disp.wrapS = disp.wrapT = THREE.RepeatWrapping;
        texture1.magFilter = texture2.magFilter = THREE.LinearFilter;
        texture1.minFilter = texture2.minFilter = THREE.LinearFilter;
        // texture1.anisotropy = this.renderer.capabilities.getMaxAnisotropy();
        // texture2.anisotropy = this.renderer.capabilities.getMaxAnisotropy();

        this.mat = new THREE.ShaderMaterial({
          uniforms: {
            effectFactorX: {type: "f", value: intensityX},
            effectFactorY: {type: "f", value: intensityY},
            dispFactor: {type: "f", value: 0.0},
            texture1: {type: "t", value: texture1},
            texture2: {type: "t", value: texture2},
            disp: {type: "t", value: disp}
          },
          vertexShader: values[0][0],
          fragmentShader: values[0][1],
          transparent: false,
          opacity: 1.0
        });

        var geometry = new THREE.PlaneBufferGeometry(texture1.image.width, texture1.image.height, 1);
        var object = new THREE.Mesh(geometry, this.mat);
        this.scene.add(object);

        this.ready = true;
        if (this.enabled) {
          this.animate();
        }

      }, this))
    }

    // Load shaders
    VICCHomeImageCanvas.prototype.loadShaders = function (vertexUrl, fragmentUrl) {
      return new Promise($.proxy(function (resolve, reject) {

        var vertexShader = false;
        var fragmentShader = false;

        var vertex_loader = new THREE.FileLoader(THREE.DefaultLoadingManager);
        vertex_loader.setResponseType('text');
        vertex_loader.load(vertexUrl, function (data) {
          vertexShader = data;
          if (vertexShader && fragmentShader) {
            resolve([vertexShader, fragmentShader]);
          }
        }, false, reject);

        var fragment_loader = new THREE.FileLoader(THREE.DefaultLoadingManager);
        fragment_loader.setResponseType('text');
        fragment_loader.load(fragmentUrl, function (data) {
          fragmentShader = data;
          if (vertexShader && fragmentShader) {
            resolve([vertexShader, fragmentShader]);
          }
        }, false, reject);

      }, this));
    };

    // Load textures
    VICCHomeImageCanvas.prototype.loadTextures = function (textures) {
      return new Promise($.proxy(function (resolve, reject) {

        const loader = new THREE.TextureLoader();
        var loaded = 0;
        var loadedTextures = [];

        // load a resource
        for (let i = 0; i < textures.length; i++) {
          loader.load(textures[i], function (texture) {
              loadedTextures[i] = texture;
              loaded++;
              if (loaded >= textures.length) {
                resolve(loadedTextures);
              }
            }, undefined, function (err) {
              reject(err);
            }
          );
        }

      }, this));
    };

    VICCHomeImageCanvas.prototype.createRenderer = function (dom) {

      this.parent = $(this.parentSelector, dom)

      this.renderer = new THREE.WebGLRenderer({
        alpha: false,
        antialias: false,
        preserveDrawingBuffer: true,
        canvas: $("canvas", this.parent).get(0),
      });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setClearColor(0xFFFFFFF, 1.0);

      // Hide renderer until first draw
      $(this.renderer.domElement).css("display", "none");

    }

    VICCHomeImageCanvas.prototype.resize = function () {

      requestAnimationFrame(function () {
        var texture1 = this.mat.uniforms.texture1.value;
        var ratioImage = texture1.image.width / texture1.image.height;
        var ratioRenderer = $("img.before", this.parent).outerWidth() / $("img.before", this.parent).outerHeight();
        // var ratioRenderer = this.parent.offsetWidth / this.parent.offsetHeight;

        this.camera.left = (ratioImage > ratioRenderer ? texture1.image.width : texture1.image.height * ratioRenderer) / -2;
        this.camera.right = (ratioImage > ratioRenderer ? texture1.image.width : texture1.image.height * ratioRenderer) / 2;
        this.camera.top = (ratioImage > ratioRenderer ? texture1.image.width / ratioRenderer : texture1.image.height) / 2;
        this.camera.bottom = (ratioImage > ratioRenderer ? texture1.image.width / ratioRenderer : texture1.image.height) / -2;
        this.camera.updateProjectionMatrix();

        if (this.renderer) {
          this.width = $("img.before", this.parent).outerWidth();
          this.height = $("img.before", this.parent).height();

          if (this.width != 0 && this.height != 0) {
            this.renderer.setSize(this.width, this.height);
            $(this).trigger('ready');
          }
        }

        this.lastRenderedAnimateValue = -1;
      }.bind(this));
    }

    VICCHomeImageCanvas.prototype.animate = function () {
      if (!this.enabled) {
        return;
      }

      requestAnimationFrame(this.animate.bind(this));

      if (this.width != $("img.before", this.parent).outerWidth() || this.height != $("img.before", this.parent).outerWidth()) {
        this.resize();
      }

      if (this.isFirstDraw) {
        this.isFirstDraw = false;
      } else {
        requestAnimationFrame($.proxy(function () {
          $(this.renderer.domElement).parent().find("img.before").css("visibility", "hidden");
          $(this.renderer.domElement).parent().find("img.after").css("visibility", "hidden");
          $(this.renderer.domElement).css("display", "block");
        }, this));
      }

      if (this.lastRenderedAnimateValue != this.animateValue) {
        this.mat.uniforms.dispFactor.value = this.animateValue;
        this.renderer.render(this.scene, this.camera);
      }

      this.lastRenderedAnimateValue = this.animateValue;
    }


    VICCHomeImageCanvas.prototype.enableFreeMode = function (value) {

      if (value == true) {
        $(this.renderer.domElement).on("mouseover touchstart", $.proxy(function () {
          gsap.to(this, 1, {
            animateValue: 0,
            ease: Quad.easeInOut,
          })
        }, this));
        $(this.renderer.domElement).on("mouseout touchend", $.proxy(function () {
          gsap.to(this, 1, {
            animateValue: 1,
            ease: Quad.easeInOut,
          })
        }, this));

      } else {
        $(this.renderer.domElement).off("mouseout touchstart mouseout touchend");
      }
    }

    VICCHomeImageCanvas.prototype.attach = function (dom) {
      if (!this.enabled) {
        this.enabled = true;
        this.width = 0;
        this.height = 0;

        window.addEventListener('resize', this.resizeCallback);

        this.createRenderer(dom);

        if (this.ready == true) {
          // this.resize();
          this.animate();
        }
      }
    }

    VICCHomeImageCanvas.prototype.dettach = function () {
      this.enabled = false;
      this.enableFreeMode(false);

      window.removeEventListener('resize', this.resizeCallback);

      if (this.renderer != false) {
        this.renderer.dispose();
        this.renderer = false;
        this.isFirstDraw = true;
        this.width = 0;
        this.height = 0
      }
    }

    // Expose VICCHomeImageCanvas
    window.VICCHomeImageCanvas = VICCHomeImageCanvas;
  }

)
(jQuery, Promise);
